module.exports = __webpack_public_path__ + "media/assets/images/flags/ga-fa5872f83eedec692b6e7fc4e235235f.svg";